class AmicheMiniConfigurator extends HTMLElement {
  constructor() {
    super();
    this.productRoot = this.closest('.product') || document;

    this.sessoSelect = this.querySelector('[data-amiche-mini-sesso]');
    this.femminaFields = this.querySelector('[data-amiche-mini-femmina-fields]');
    this.maschioFields = this.querySelector('[data-amiche-mini-maschio-fields]');
    this.gadgetSelect = this.querySelector('[data-amiche-mini-gadget-select]');

    this.pantaloniToggle = this.querySelector('[data-amiche-mini-pantaloni-toggle]');
    this.pantaloniColorRow = this.querySelector('[data-amiche-mini-pantaloni-color]');
    this.jeansColorRow = this.querySelector('[data-amiche-mini-jeans-color]');
    this.papillonToggle = this.querySelector('[data-amiche-mini-papillon-toggle]');
    this.papillonFields = this.querySelector('[data-amiche-mini-papillon-fields]');

    this.palloncinoToggle = this.querySelector('[data-amiche-mini-palloncino-toggle]');
    this.palloncinoFields = this.querySelector('[data-amiche-mini-palloncino-fields]');

    if (this.sessoSelect) this.sessoSelect.addEventListener('change', this.applySesso.bind(this));
    if (this.pantaloniToggle) this.pantaloniToggle.addEventListener('change', this.applyPantaloniToggle.bind(this));
    if (this.papillonToggle) this.papillonToggle.addEventListener('change', this.applyPapillonToggle.bind(this));
    if (this.gadgetSelect) this.gadgetSelect.addEventListener('change', this.recomputeGadgetVariant.bind(this));
    if (this.palloncinoToggle) this.palloncinoToggle.addEventListener('change', this.applyPalloncinoToggle.bind(this));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
    }

    this.applySesso();
    this.applyPalloncinoToggle();
  }

  setGroupDisabled(group, disabled) {
    if (!group) return;
    group.hidden = disabled;
    group.querySelectorAll('input, select, textarea').forEach((el) => {
      el.disabled = disabled;
    });
  }

  applySesso() {
    const value = this.sessoSelect ? this.sessoSelect.value : '';
    const isFemmina = value === 'Femmina';
    const isMaschio = value === 'Maschio';
    this.setGroupDisabled(this.femminaFields, !isFemmina);
    this.setGroupDisabled(this.maschioFields, !isMaschio);
    if (isMaschio) {
      this.applyPantaloniToggle();
      this.applyPapillonToggle();
    }
    this.recomputeGadgetVariant();
  }

  applyPantaloniToggle() {
    if (!this.pantaloniToggle) return;
    const isPantaloni = this.pantaloniToggle.value === 'Pantaloni';
    const isJeans = this.pantaloniToggle.value === 'Jeans';
    this.setGroupDisabled(this.pantaloniColorRow, !isPantaloni);
    this.setGroupDisabled(this.jeansColorRow, !isJeans);
  }

  applyPapillonToggle() {
    if (!this.papillonToggle) return;
    const showPapillon = this.papillonToggle.value === 'Sì';
    this.setGroupDisabled(this.papillonFields, !showPapillon);
  }

  applyPalloncinoToggle() {
    if (!this.palloncinoToggle) return;
    const showFields = this.palloncinoToggle.value === 'Sì';
    this.setGroupDisabled(this.palloncinoFields, !showFields);
  }

  onVariantChange() {
    // Nothing else on this product depends on a native variant reflecting
    // back into the UI — the gadget option is set here, not read from here.
  }

  recomputeGadgetVariant() {
    const isFemmina = this.sessoSelect && this.sessoSelect.value === 'Femmina';
    const gadgetValue = isFemmina && this.gadgetSelect ? this.gadgetSelect.value : 'Nessuno';
    const inputs = this.productRoot.querySelectorAll('input[data-option-name="Gadget"]');
    if (!inputs.length) return;
    const target = Array.from(inputs).find((i) => i.value === gadgetValue);
    if (target && !target.checked) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
}

customElements.define('amiche-mini-configurator', AmicheMiniConfigurator);
